// extracted by mini-css-extract-plugin
export var text = "_46-0";